import React from 'react';

import { useIntl } from 'react-intl';

import { useStoreContext } from 'state/store';
import { routes } from 'utils/routing';

import { UnauthenticatedEmptyStateImage } from './images';
import {
  EmptyStateWrapper,
  HeaderText,
  ImageWrapper,
  StyledActionButtonLink,
  SubText,
} from './styled';

export const NoRecentOrdersEmptyState = () => {
  const { formatMessage } = useIntl();
  const { isStoreOpenAndAvailable } = useStoreContext();

  return (
    <EmptyStateWrapper>
      <ImageWrapper>
        <UnauthenticatedEmptyStateImage />
      </ImageWrapper>
      <HeaderText>{formatMessage({ id: 'noRecentItemsHeader' })}</HeaderText>
      <SubText>{formatMessage({ id: 'noRecentItemsSubheader' })}</SubText>
      <StyledActionButtonLink
        to={isStoreOpenAndAvailable ? `${routes.menu}` : `${routes.storeLocator}`}
      >
        {formatMessage({ id: 'orderNow' })}
      </StyledActionButtonLink>
    </EmptyStateWrapper>
  );
};
